import {deserialize} from "serializr";
import firebase from "firebase";
import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import {PackageBackendModel} from "@/modules/mpackages/models/PackageBackendModel";
import {PackageBackendDeployedModel} from "@/modules/mpackages/models/PackageBackendDeployedModel";

export default {
    namespaced: true,
    state: {
        mPackages: [],
        mDeployedPackages: [],
    },
    getters: {
         getPackages: state => {
             return state.mPackages;
         },
        getDeployedPackages: state => {
            return state.mDeployedPackages;
        },
    },
    mutations: {
         setPackages(state, values) {
             state.mPackages = values;
         },
         setDeployedPackages(state, values) {
            state.mDeployedPackages = values;
         }
    },
    actions: {
        init({/*commit*/}) {
            console.info('package-store initialized.');
            //return PackageStoreUtils.fethPackages()
        },
        getNewPackage({/*commit*/}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getNewPackage', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            return deserialize(PackageBackendModel, JSON.parse(data))
                                        }).catch((error) => {
                                            throw error
                                        }).finally(() => {
                                            PackageStoreUtils.fethPackages()
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethPackageContent({/*commit*/}, packageId){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getPackageContent/'+packageId, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                    .then((data)=>{
                                        throw data
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }else{
                                    return data.text()
                                    .then((data)=>{
                                        return data
                                    }).catch((error) => {
                                        throw error
                                    })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethPackages({commit}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getPackages', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            let obj = JSON.parse(data)
                                            if (obj == null){obj = []}
                                            let values = obj.map(v => deserialize(PackageBackendModel, v));
                                            commit('setPackages', values)
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        deletePackage({/*commit*/}, packageId){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'deletePackage/' + packageId, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return PackageStoreUtils.fethPackages()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        updatePackage({/*commit*/}, data){
            console.log(data)
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body:JSON.stringify(data),
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'updatePackage', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return PackageStoreUtils.fethPackages()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },

        // PACKAGE FILES
        uploadPackageFile({/*commit*/}, data){
            //console.log(JSON.stringify(data))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body:JSON.stringify(data),
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'uploadPackageFile', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            return data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        deletePackageFile({/*commit*/}, data){
            //console.log(JSON.stringify(data))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            //body:JSON.stringify(data),
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'deletePackageFile/'+data.packageId+'/'+data.fileName, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            return data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethPackageFile({/*commit*/}, data){
            //console.log(JSON.stringify(data))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getPackageFile/'+data.packageId+'/'+data.fileName, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.blob()
                                        .then((data)=>{
                                            return data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },

        // DEPLOY
        deployPackage({/*commit*/}, data){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body:JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'deployPackage', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.blob()
                                        .then((data)=>{
                                            return data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },

        //ACTIVE
        fethDeployedPackageList({commit}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getDeployedPackageList', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                    .then((data)=>{
                                        throw data
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }else{
                                    return data.text()
                                    .then((data)=>{
                                        let obj = JSON.parse(data)
                                        if (obj == null){obj = []}
                                        //console.log(obj)
                                        let values = obj.map(v => deserialize(PackageBackendDeployedModel, v));
                                        commit('setDeployedPackages', values)
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setDeployedPackageAudience({/*commit*/}, value){
            console.log('setDeployedPackageAudience:', JSON.stringify(value))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setDeployedPackageAudience', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                    .then((data)=>{
                                        throw data
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }else{
                                    return PackageStoreUtils.fethDeployedPackageList()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setDeployedPackageClientVersion({/*commit*/}, value){
            console.log('setDeployedPackageAudience:', JSON.stringify(value))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setDeployedPackageClientVersion', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return PackageStoreUtils.fethDeployedPackageList()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        removeDeployedPackage({/*commit*/}, name){
            console.log('removeDeployedPackage:', name)
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeDeployedPackage/' + name, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return PackageStoreUtils.fethDeployedPackageList()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },

    }
}

